import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IBannerSettings } from "./interface";
import { Card, Col, Form, Row } from "react-bootstrap";
import { ErrorToast, SuccessToast } from "../../shared/toasters/toasters";
import { InitEditorMulti } from "../../shared/tinyMce/InitEditorMulti";
import { AdminBannerSettingsService } from "./service";
import { PICTURE_URL } from "../../helpers/api.routes";
import { ConfirmDelete } from "../../shared/components/ConfirmDelete";
import RichTextEditor from "../../shared/editor/RichTextEditor";

const BannerSettings = () => {
  const { t } = useTranslation();
  const [state, setState] = useState<IBannerSettings | null>(null);
  const [image, setImage] = useState<File | null>(null);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setState(
      (prevState) => ({ ...prevState, [name]: value }) as IBannerSettings
    );
  };

  const handleText = (text: string) => {
    setState((prevState) => ({ ...prevState, text }) as IBannerSettings);
  };

  const fileHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.files && setImage(e.target.files[0]);
  };

  const handleDelete = () => {
    AdminBannerSettingsService.delete()
      .then((response) => {
        SuccessToast(t(`banner.successfully_deleted_image`));
        setState(response.data);
        setShow(false);
      })
      .catch(ErrorToast);
  };

  const submitHandler = () => {
    const formData = new FormData();
    formData.append("body", JSON.stringify(state));
    image && formData.append("image", image);

    AdminBannerSettingsService.create(formData)
      .then((response) => {
        SuccessToast(t(`banner.successfully_updated_settings`));
        setState(response.data);
      })
      .catch(ErrorToast);
  };

  useEffect(() => {
    AdminBannerSettingsService.get()
      .then((response) => {
        const { data } = response;
        setState(data);
        InitEditorMulti(data?.text ?? "", handleText, ".text");
      })
      .catch(ErrorToast);
  }, []);

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        submitHandler();
      }}
    >
      <Card>
        <Card.Body>
          <Row>
            <Col md={6} className="mt-2">
              <label>{t("global.title")}</label>
              <input
                name="title"
                type="text"
                className="form-control"
                onChange={changeHandler}
                value={state?.title}
              />
            </Col>
            <Col md={12} className="my-3" id="custom-editor">
              <RichTextEditor
                label={t("global.text")}
                value={state?.text ?? ""}
                onChange={(newContent) =>
                  setState((prev: any) => ({
                    ...prev,
                    text: newContent,
                  }))
                }
              />

              {/* <label htmlFor="title" className="required-field">
                                {t("global.text")}
                            </label>
                            <textarea className="editor text"/> */}
            </Col>
            <Col ms={12}>
              <div className="mt-3">
                <label htmlFor="imageFile"> {t("download.image")}</label>
                <input
                  onChange={fileHandler}
                  className="form-control"
                  type="file"
                  accept="image/*"
                  id="imageFile"
                />
              </div>
              {state?.image && (
                <div className="d-inline-block position-relative mt-3">
                  <img
                    className="object-fit-cover"
                    width={200}
                    height={200}
                    src={PICTURE_URL + state?.image.path}
                    data-holder-rendered="true"
                    alt={state?.image?.name}
                    style={{ margin: "2px" }}
                  />
                  <i
                    onClick={handleShow}
                    className={
                      "ri-delete-bin-fill bg-danger text-white delete-icon-position"
                    }
                  ></i>
                </div>
              )}
            </Col>
          </Row>
          <div className="col-12 mt-5 d-flex justify-content-end">
            <button className="btn btn-primary ms-3" type={"submit"}>
              {t("global.save")}
            </button>
          </div>
          <ConfirmDelete
            show={show}
            setShow={setShow}
            itemName={state?.image?.name}
            deleteHandler={handleDelete}
            product={state}
            selectedProduct={state}
          />
        </Card.Body>
      </Card>
    </Form>
  );
};

export default BannerSettings;
